export default "__VITE_ASSET__DdQ1mPVu__"